import {formatText} from 'presentation/utils';
import React, {PropsWithChildren} from 'react';
import {WeekDays} from '../WeekDays';
import {CalendarProps} from './Calendar.types';
import {CalendarDays, CalendarTitle, CalendarTitleContainer, Container} from './styles';

const Calendar = ({
	month,
	year,
	showNextMonth,
	lang = 'pt-BR',
	children,
	typeTextWeekDay,
}: PropsWithChildren<CalendarProps>) => {
	const monthName = new Date(`1970/${month + 1}/01`).toLocaleString(lang, {
		month: 'long',
	});
	const monthNameFormatted = formatText(monthName);

	return (
		<Container>
			{showNextMonth ? (
				<CalendarTitleContainer>
					<CalendarTitle>{`${monthNameFormatted} ${year}`}</CalendarTitle>
				</CalendarTitleContainer>
			) : null}
			<WeekDays lang={lang} typeTextWeekDay={typeTextWeekDay} />
			<CalendarDays>{children}</CalendarDays>
		</Container>
	);
};

export {Calendar};
